import { render } from "./Empty.vue?vue&type=template&id=80f31868&scoped=true&bindings={}"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-80f31868"

export default script